module.exports = __webpack_public_path__ + "static/media/25.ad466366.jpg";